<template>
  <BasePanel>
    <ReportsTableTopActionBar />

    <BaseTable :data="tableData" sortBy="songs" sortOrder="asc">
      <BaseTableColumn label="Full Name" colClass="md:hidden">
        <template #default="row">
          {{ row.firstName }} {{ row.lastName }}
        </template>
      </BaseTableColumn>
      <BaseTableColumn
        show="firstName"
        label="First Name"
        colClass="hidden md:table-cell"
      ></BaseTableColumn>
      <BaseTableColumn
        show="lastName"
        label="Last Name"
        colClass="hidden md:table-cell"
      ></BaseTableColumn>
      <BaseTableColumn
        show="instrument"
        label="Long Name for Musical Device"
        colClass="hidden md:table-cell"
      ></BaseTableColumn>
      <BaseTableColumn show="songs" label="Songs"></BaseTableColumn>
      <BaseTableColumn
        show="birthday"
        label="Birthday"
        :formatter="dateFormatter"
        colClass="hidden md:table-cell"
      ></BaseTableColumn>
      <BaseTableColumn :sortable="false">
        <template #header>
          <div class="text-center">
            <BaseCheckbox
              :checked="selectAll"
              @toggle="selectAll = !selectAll"
              id="select-all"
            />
          </div>
        </template>
        <template #default="row">
          <div class="text-center">
            <BaseLink
              :href="`#${row.firstName}`"
              class="text-deep-cerulean hover:underline"
              >Edit</BaseLink
            >
          </div>
        </template>
      </BaseTableColumn>
    </BaseTable>

    <ReportsTableBottomActionBar />
  </BasePanel>
</template>

<script>
import ReportsTableBottomActionBar from './ReportsTableBottomActionBar'
import ReportsTableTopActionBar from './ReportsTableTopActionBar'

export default {
  name: 'ReportsTable',
  components: {
    ReportsTableBottomActionBar,
    ReportsTableTopActionBar
  },
  data() {
    return {
      selectAll: false,
      tableData: [
        {
          firstName: 'John',
          lastName: 'Lennon Shshs snbsbjsbjs msmsm',
          instrument: 'Guitar',
          birthday: '1940-10-04',
          songs: 72
        },
        {
          firstName: 'Paul',
          lastName: 'McCartney',
          instrument: 'Bass',
          birthday: '1942-06-18',
          songs: 70
        },
        {
          firstName: 'George',
          lastName: 'Harrison',
          instrument: 'Guitar',
          birthday: '1943-02-25',
          songs: 22
        },
        {
          firstName: 'Ringo',
          lastName: 'Starr',
          instrument: 'Drums',
          birthday: '1940-07-07',
          songs: 2
        }
      ]
    }
  },
  methods: {
    dateFormatter(value) {
      return new Date(value).toDateString()
    }
  }
}
</script>
